import * as actionTypes from '../actionTypes/redirectNode';

export default {
  getRedirectNode: () => ({
    type: actionTypes.GET_REDIRECT_NODE,
    payload: {},
  }),
  setRedirectNode: (data) => ({
    type: actionTypes.SET_REDIRECT_NODE,
    payload: {
      ...data,
    },
  }),
};
